import { render } from "./RegistrationLoginComponent.vue?vue&type=template&id=7ea22227&scoped=true"
import script from "./RegistrationLoginComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationLoginComponent.vue?vue&type=script&lang=js"

import "./RegistrationLoginComponent.vue?vue&type=style&index=0&id=7ea22227&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ea22227"]])

export default __exports__